import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const fetchDiscountApprovalHistory = createAsyncThunk("discountApprovalHistory/fetch", async (requestId, { rejectWithValue }) => {
	try {
		const { data } = await axiosHttp.get(`/discount-request/approval/${requestId}/history`);
		return data?.data || [];
	} catch (err) {
		return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to load approval history");
	}
});

const DiscountApprovalHistorySlice = createSlice({
	name: "DiscountApprovalHistorySlice",
	initialState: {
		data: [],
		isLoading: false,
		error: null,
	},
	reducers: {},
	extraReducers: (builder) => {
		builder
			.addCase(fetchDiscountApprovalHistory.pending, (state) => {
				state.isLoading = true;
				state.error = null;
			})
			.addCase(fetchDiscountApprovalHistory.fulfilled, (state, action) => {
				state.isLoading = false;
				state.data = action.payload;
			})
			.addCase(fetchDiscountApprovalHistory.rejected, (state, action) => {
				state.isLoading = false;
				state.error = action.payload || "Failed to load approval history";
			});
	},
});

export default DiscountApprovalHistorySlice.reducer;
